import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-files",
  "use": "icon-soc-l1-files-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-files\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M256 160h320l192 192v512H256V160zm64 64v576h384V384H512V224H320zm256 0v128h128L576 224z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-files.svg
// module id = CjaD
// module chunks = 491